import { gql } from '@apollo/client';

export const FETCH_ENUM_VALUES = gql`
    query fetchEnumValues($name: String!) {
        __type(name: $name) {
            name
            enumValues {
                name
            }
        }
    }
`;
